import * as React from 'react';

import { SegmentLabel } from '@acceligentllc/storybook';

import AddressField from 'af-components/SharedForms/WorkLocationAddress/AddressField';

import { formSectionClass, formSectionClassRow } from '../../helpers';

type Props = {
	formName: string;
	latitude: Nullable<number>;
	longitude: Nullable<number>;
	// Deliberate like this undefined used to distinguish new address and no country
	country: Nullable<string> | undefined;
	clearAddress: () => void;
};

const WorkLocationSection: React.FC<Props> = ({ formName, latitude, longitude, country, clearAddress }) => {
	return (
		<div className={formSectionClass}>
			<div className={formSectionClassRow}>
				<SegmentLabel
					label="Work Location"
					tooltip={`
						Location where work is being done — used to determine the time zone for payroll reports.
						If a Work Order has no work location set, the time zone is taken from this address;
						otherwise, the company's time zone is used
					`}
				/>
			</div>
			<div className="m-b-m" />
			<AddressField
				backupPropName="workLocation.backup"
				cityPropName="workLocation.city"
				clearAddress={clearAddress}
				country={country}
				countryPropName="workLocation.country"
				disabled={false}
				disableMap={false}
				disableRemove={true}
				formName={formName}
				latitude={latitude}
				locationPropName={'workLocation.location'}
				longitude={longitude}
				neighborhoodPropName="workLocation.neighborhood"
				notesPropName="workLocation.notes"
				postalCodePropName="workLocation.postalCode"
				routePropName="workLocation.street"
				statePropName="workLocation.state"
				streetNumberPropName="workLocation.streetNumber"
			/>
		</div>
	);
};

export default React.memo(WorkLocationSection);
